module.exports = __webpack_public_path__ + "img/cooperation_unit_10.415419e2.png";